import { Text } from "@fluentui/react-components";
import { faFile, faXmark } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useContext } from "react";
import { useSelectedFilesList } from "./selectedFilesList/useSelectedFilesList";
import { clsx } from "clsx/lite";
import { UploadLimits } from "@/api/openapi";
import { translate } from "@/config/translator";
import { beautifyBytes } from "@/config/utils";
import { PspContext } from "@/config/contexts";

type SelectedFilesListProps = {
  selectedFiles: File[];
  setSelectedFiles: Dispatch<SetStateAction<File[] | null>>;
  uploadLimits?: UploadLimits | undefined;
};

export function SelectedFilesList({
  selectedFiles,
  setSelectedFiles,
  uploadLimits,
}: SelectedFilesListProps) {
  const { removeSingleSelectedFile } = useSelectedFilesList({
    setSelectedFiles,
  });
  const { lang } = useContext(PspContext);

  return (
    <div className="flex flex-col gap-2">
      {selectedFiles.map((file, index) => (
        <div
          key={`selected-file-${file.name}-${index}`}
          className={clsx(
            "flex",
            "flex-row",
            "justify-between",
            "items-center",
            "border-b",
            "border-b-neutral",
            "pb-3",
            "-mx-3",
            "px-3",
          )}
        >
          <div className="flex flex-row items-center gap-1">
            <FontAwesomeIcon
              icon={faFile}
              className="text-font-secondary text-xl"
            />
            <div>
              <Text size={400}>{file.name}</Text>
              {!!uploadLimits && file.size > uploadLimits.maxFileSizeBytes && (
                <>
                  <br />
                  <span className="text-red-800">
                    {translate("fileTooLargeInfo", lang, {
                      "[bytes]": beautifyBytes(
                        uploadLimits?.maxFileSizeBytes ?? 0,
                      ),
                    })}
                  </span>
                </>
              )}
            </div>
          </div>
          <button
            onClick={() => removeSingleSelectedFile(index)}
            className={clsx(
              "p-1",
              "flex",
              "justify-center",
              "items-center",
              "rounded-md",
              "hover:bg-neutral",
              "duration-200",
              "ease-in-out",
              "aspect-square",
            )}
          >
            <FontAwesomeIcon
              icon={faXmark}
              className="text-font-black text-lg cursor-pointer"
            />
          </button>
        </div>
      ))}
    </div>
  );
}
